import { useEffect } from "react";
import { getAemFooter } from "~/utils/adobe";
import { fetchAemFooter } from "~/common/api/adobe";

export function FooterView() {
  const addFooter = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    document.body.appendChild(div);
  };

  useEffect(() => {
    const fetchFooter = async () => {
      const content = await fetchAemFooter();
      const body = content?.body;
      const aemUrl = content?.aemUrl;
      // console.log(`Fetched AEM Footer HTML ${aemUrl}:`, body);

      const footerHtml = await getAemFooter(aemUrl, body);
      addFooter(footerHtml ?? "");
    };

    fetchFooter();
  }, []);

  // we inject all of the footer HTML directly into the body, so nothing to render here
  return null;
}
